export default __webpack_public_path__ + "a5ab93b9146e54b282b919e71afe5cd6.png";